import { FC } from 'react'
import * as cn from 'classnames'
import SvgIcon from 'components/atoms/SvgIcon'
import CrossSvg from 'icons/cross.svg'

import * as styles from 'components/features/insights/Insight/Annotation.css'
import { Markdown } from 'components/features/pfm/Markdown/Markdown'

type AnnotationProps = {
  nodeId?: string
  theme: 'golden' | 'blue'
  size?: 'responsive' | 'fixed'
  isPostMode?: boolean
  isExpanded: boolean
  isModuleInsight: boolean
  title: string
  markdown: string
  onCloseButtonClick: () => void
}

const Annotation: FC<AnnotationProps> = (props) => {
  const {
    theme,
    size = 'responsive',
    isExpanded,
    isModuleInsight,
    title,
    markdown,
    nodeId,
    onCloseButtonClick,
    isPostMode,
  } = props

  const annotationClassName = cn(
    styles.annotation,
    styles[theme], styles[size],
    {
      [styles.expanded]: isExpanded,
      [styles.moduleInsight]: isModuleInsight,
      [styles.postMode]: isPostMode,
    }
  )

  return (
    <section className={ annotationClassName } id={ nodeId }>
      <header className={ styles.header }>
        <div className={ styles.closeButton } onClick={ onCloseButtonClick }>
          <SvgIcon src={ CrossSvg } />
        </div>
      </header>
      <h6 className={ styles.title }>
        { title }
      </h6>
      <div className={ styles.content }>
        <div className={ styles.text }>
          <Markdown text={ markdown } />
        </div>
      </div>
    </section>
  )
}

export default Annotation
